<template>
  <div>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="50px"
        >
          <el-form-item
            v-if="isMobile() && !filterShow"
            label="编号"
            prop="number"
          >
            <el-input
              size="small"
              v-model="filter.number"
              autocomplete="off"
              @keyup.enter.native="requestOrders"
            ></el-input>
          </el-form-item>
          <div class="filter-block" v-show="filterShow || !isMobile()">
            <el-form-item label="单号" prop="number">
              <el-input
                size="small"
                v-model="filter.number"
                autocomplete="off"
                @keyup.enter.native="requestOrders"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
              label="中间商"
              prop="dealer_id"
              v-if="auth.isPlatformUser()"
            >
              <dealer-select
                :val="filter.dealer_id"
                @change="filter.dealer_id = $event"
              ></dealer-select>
            </el-form-item> -->
            <el-form-item label="客户" prop="customer_id">
              <customer-select
                style="width: 100%"
                :val="filter.customer_id"
                @change="filter.customer_id = $event"
              ></customer-select>
              <!-- <el-select
                size="small"
                v-model="filter.customer_id"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in customers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item
              label="状态"
              prop="status"
              v-if="deleted == 0 && status <= 0"
            >
              <el-select
                size="small"
                v-model="filter.status"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, key) in customerOrderStatusMap"
                  :key="key"
                  :label="item.name"
                  :value="key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="销售"
              prop="user_id"
              v-if="!consult"
              v-permission="Auth.userList"
            >
              <el-select
                size="small"
                v-model="filter.user_id"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in sales"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="日期" prop="date">
              <el-date-picker
                v-model="filter.date"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </div>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button type="primary" size="small" @click="requestOrders()"
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
          <div
            class="flex-row-base"
            v-if="isMobile()"
            @click="
              filterShow = !filterShow
              scrollToTop()
            "
          >
            <i
              class="text-gray"
              :class="filterShow ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            ></i>
            <span class="text-info-12">
              {{ filterShow ? '隐藏高级筛选' : '展开高级筛选' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-if="!consult && deleted == 0 && status <= 0"
          @click="startCustomerOrder"
          v-permission="Auth.orderNew"
          >新报价</el-button
        >
        <file-button
          style="float: right"
          obj="order"
          :importButton="false"
          v-if="deleted == 0"
          :filter="filter"
          @importCallback="reset"
          v-permission="Auth.orderIE"
        ></file-button>
      </div>
      <el-table
        v-if="!isMobile()"
        :data="orders"
        v-loading="loading"
        class="mt-10"
      >
        <el-table-column prop="number" label="编号/客户/项目" min-width="150">
          <template slot-scope="scope">
            <order-link :order="scope.row"></order-link>
            <br />
            <span>{{ scope.row.customer.name }}</span>
            <template v-if="scope.row.order_info.project_name.length > 0">
              <br />
              <span>{{ scope.row.order_info.project_name }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="产品明细" min-width="150">
          <template slot-scope="scope">
            <template v-for="device in scope.row.order_info.devices">
              <span
                class="item-tag"
                v-for="item in device.items"
                :key="item.id"
              >
                {{ item.item.part_number }}
                <i>x{{ item.count }}</i>
              </span>
            </template>
            <span
              class="item-tag"
              :key="item.id"
              v-for="item in scope.row.order_info.products"
            >
              {{ item.item.part_number }}
              <i>x{{ item.count }}</i>
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="中间商" width="200" align="center" v-if="auth.isPlatformUser()">
          <template slot-scope="scope">
            <span>{{ scope.row.dealer.name }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="sale"
          :label="consult ? '询价人' : '销售'"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{
              consult ? scope.row.customer_user.name : scope.row.user.name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="报价类型"
          width="150"
          align="center"
          v-if="!consult"
        >
          <template slot-scope="scope">
            {{ scope.row.order_info.type == 2 ? '服务报价' : '备件报价' }}
          </template>
        </el-table-column>
        <el-table-column prop="date" label="日期" width="150" align="center">
          <template slot-scope="scope">
            <span>
              {{ formatTime(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="订单金额(￥)"
          width="140"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.order_info.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <status-tag
              v-if="deleted == 0"
              :type="customerOrderStatusMap[scope.row.status].type"
              :name="customerOrderStatusMap[scope.row.status].name"
            ></status-tag>
            <status-tag v-else type="gray" name="已删除"> </status-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100" align="center">
          <template slot-scope="scope">
            <order-link :order="scope.row" v-permission="Auth.orderShow">
              <el-button slot="content" size="mini" type="primary" plain
                >查看详情</el-button
              >
            </order-link>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="item in orders" :key="item.id">
          <div class="flex-row-between">
            <order-link :order="item"></order-link>
            <span>￥{{ item.order_info.amount }}</span>
          </div>
          <div class="font-12">客户：{{ item.customer.name }}</div>
          <div class="font-12 flex-row-between">
            <span>销售：{{ item.user.name }}</span>
          </div>
          <div class="font-12 flex-row-between">
            <span>{{ formatTime(item.created_at) }}</span>
            <span>
              <status-tag
                v-if="deleted == 0"
                :type="customerOrderStatusMap[item.status].type"
                :name="customerOrderStatusMap[item.status].name"
              ></status-tag>
              <status-tag v-else type="gray" name="已删除"> </status-tag>
            </span>
          </div>
        </li>
      </ul>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <customer-selector
      :show.sync="customerSelectorVisible"
      :activeCustomers="activeCustomers"
      @selected="selectedOrderCustomer"
    ></customer-selector>
  </div>
</template>

<script>
import {
  customerList,
  userList,
  customerOrderList,
  customerActiveList,
} from '../../service/getData'
import { CustomerOrderStatusMap } from '../../config/global'
import auth from '@/util/auth'
import { clone } from '@/util'
import { formatTime } from '@/util/index'
import CustomerSelector from '@/components/customer_selector'
import { hasAuth } from '@/permission'
import math from '../../util/math'
import { isMobile, scrollToTop } from '../../util'
import CustomerSelect from '@/components/select/customer_select'
import DealerSelect from '@/components/select/dealer_select'

export default {
  components: { CustomerSelector, CustomerSelect, DealerSelect },
  props: {
    deleted: {
      type: Number,
      default: 0,
    },
    status: {
      type: Number,
      default: 0,
    },
    consult: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobile,
      scrollToTop,
      filterShow: false,
      filter: {
        number: '',
        customer_id: '',
        dealer_id: '',
        status: '',
        not_status: 0,
        date: null,
        user_id: '',
        size: 20,
        page: 1,
        is_consult_list: false,
      },
      total: 0,
      sales: [],
      customers: [],
      orders: [],
      auth,
      customerSelectorVisible: false,
      customerOrderStatusMap: CustomerOrderStatusMap,
      formatTime: formatTime,
      loading: false,
      activeCustomers: [],
    }
  },
  watch: {
    'filter.page': function () {
      this.requestOrders()
    },
  },
  created() {
    if (this.status > 0) {
      this.filter.status = this.status
    }
    if (this.status < 0) {
      this.filter.not_status = Math.abs(this.status)
    }

    if (this.consult) {
      this.filter.is_consult_list = true
    }

    // this.requestCustomers()

    if (hasAuth('userList')) {
      this.requestSales()
    }

    this.requestOrders()
  },
  methods: {
    async requestCustomers() {
      let res = await customerList()
      if (res.code == 0) {
        this.customers = res.data.list
      }
    },
    async requestSales() {
      let res = await userList()
      if (res.code == 0) {
        this.sales = res.data.list
      }
    },
    async requestOrders() {
      let data = clone(this.filter)
      data.page = data.page - 1
      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }

      data.deleted = this.deleted

      this.loading = true
      let res = await customerOrderList(data)
      if (res.code == 0) {
        this.orders = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    reset() {
      this.$refs['filterForm'].resetFields()
      this.filter.page = 1
      this.requestOrders()
    },
    async requestActiveCustomer() {
      let res = await customerActiveList()
      if (res.code == 0) {
        this.activeCustomers = res.data.list
      }
    },
    startCustomerOrder() {
      this.requestActiveCustomer()
      this.customerSelectorVisible = true
    },
    selectedOrderCustomer(customer) {
      this.$router.push('/dashboard/order_editor?customer=' + customer.id)
    },
  },
}
</script>

<style scoped>
.el-input {
  width: 220px;
}
</style>